import { Routes } from '@angular/router';
import { titleFormatter } from '@core/utils/general.utils';

export const importRoutes: Routes = [
  {
    path: 'import',
    title: titleFormatter('Import'),
    data: { title: 'Import' },
    loadComponent: () => import('./pages/Home/Home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'import/kickertool',
    title: titleFormatter('Import Kickertool Matches'),
    data: { title: 'Import Kickertool Matches' },
    loadComponent: () => import('./pages/Kickertool/Kickertool.component').then((m) => m.KickertoolComponent),
  },
  {
    path: 'import/kickertool-v3-json',
    title: titleFormatter('Import Kickertool V3 JSON'),
    data: { title: 'Import Kickertool V3 JSON' },
    loadComponent: () => import('./pages/KickertoolV3Json/KickertoolV3Json.component').then((m) => m.KickertoolV3JsonComponent),
  },
];
